import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

export default class ErrorBoundary extends React.Component {
    static propTypes = {
        /** The children to render when there is no error */
        children: PropTypes.node.isRequired,

        /** A component to render as a fallback if there is an error */
        fallbackElement: PropTypes.node
    };

    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope((scope) => {
            scope.setExtras(errorInfo);
            Sentry.captureException(error);
        });
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.error(error, errorInfo);
        }
    }

    render() {
        const { children, fallbackElement } = this.props;

        if (this.state.hasError) {
            return fallbackElement || null;
        }

        return children;
    }
}
